import UltMeta, { Meta } from "./UltMeta/index";
// 海康云

// 视屏流播放器控件模式

class ThemeMode extends UltMeta {
    SIMPLE = new Meta("simple", "精简");
    PC_LIVE = new Meta("pcLive", "PC预览");
    PC_REC = new Meta("pcRec", "PC回放");
    MOBILE_LIVE = new Meta("mobileLive", "H5预览");
    MOBILE_REC = new Meta("mobileRec", "H5回放");
}
export const THEME_MODE = new ThemeMode();

export enum PLAY_VIDEO_TYPE {
    play = 1,
    back = 2
}
